import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import Cookies from 'universal-cookie';
import ErrorDialog from '../../../../components/ErrorDialog';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import EditorTipTap from "../../../../components/EditorTipTap/EditorTipTap";

export default function TerminoAccept(props) {

  const cookies = new Cookies();

  const { onClose, value: valueProp, open, idtermino, setTerminoFirmado, terminoFirmado, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [texto, setTexto] = useState("");

  const radioGroupRef = useRef(null);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleNoAceptar = () => {
    sessionStorage.clear();
    cookies.remove("accessToken");
    cookies.remove("idUsuario");
    cookies.remove("auditoria_filter_accion");
    cookies.remove("auditoria_filter_fechaDesde");
    cookies.remove("auditoria_filter_fechaHasta");
    window.location.replace('/');
  };

  const QTermino = gql`
      mutation MSaveFirmaTermino ($idTermino: Int!, $idUsuario: Int!) {
        saveFirmaTermino(
          idTermino: $idTermino,
          idUsuario: $idUsuario
        ) 
        {
          success,
          error,
          valorEsperado
        }
      }`;

  const [saveFirma, { loading, error, data }] = useMutation(QTermino, {
    onCompleted: (data) => {
      if (data.saveFirmaTermino.success) {
        toast.success("Términos y condiciones aceptados correctamente.");
        setTerminoFirmado(true);
        onClose(value);
      } else if (data.saveFirmaTermino.error === 'ERRORDB' || parseInt(data.saveFirmaTermino.error, 10) > 0) {
        setMensajeError(data.saveFirmaTermino.error);
      } else {
        setMensajeError(data.saveFirmaTermino.error);
      }
    },
    onError: (data) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleOk = () => {
    let result = saveFirma({ variables: { idTermino: idtermino, idUsuario: idUsuario } });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>

      <CustomDialog
        {...other}
        maxWidth="md"
        TransitionProps={{ onEntering: handleEntering }}
        open={open}
        title='Términos y condiciones'
        onCancel={handleNoAceptar}
        cancelText='No Aceptar'
        onAccept={handleOk}>        
        
        {value && 
          <EditorTipTap
              value={value || ""}
              editable={false}
              onChange={(html) => setTexto(html)}
          />
        }
        
      </CustomDialog>
      <ErrorDialog
        id="dlg-error-firma"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
    </>);

}